import React from "react";
import ModuleShowcasePage from "../../marketing/ModuleShowcasePage";

const AsapProfil = () => <ModuleShowcasePage moduleKey="profile" />;

export default AsapProfil;
